import Head from "next/head";
import Link from "next/link";

const baseUrl = "https://opensea.io/collection/seeds-luciensmith?search[sortAscending]=true&search[sortBy]=PRICE&search[stringTraits][0][name]=Type";

function Category({ title, search = "", children }: { title: string; search?: string; children: any }) {
	return (
		<div className="mt-6">
			<div>
				<a href={`${baseUrl}&search[stringTraits][0][values][0]=${encodeURIComponent(search || title)}`} target="_blank" rel="noreferrer">
					{title}
				</a>
			</div>
			<p>{children}</p>
		</div>
	);
}

export default function Rarity() {
	return (
		<>
			<Head>
				<title key="title">Rarity | Lucien Smith - Seeds</title>
			</Head>
			<div className="mt-6 max-w-full">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center mt-14">Rarity</h1>
				<div className="text-lg leading-7 mt-5">
					<p>
						Each of the 10,000 SEEDS is entirely unique - they are a total of 44 different each processing a multitude of variations inspired by the
						polymorphism of flowers.
					</p>
					<Category title="The Interaction of Color" search="Interaction of Color">
						~70% Chance of Drop Varying in an array of color palettes taken from art history, think Pop Art or Baroque.
					</Category>
					<Category title="Berzerkers">~15% Chance of Drop A visual explosion of color.</Category>
					<Category title="Monochromatic">~8% Chance of Drop A minimalist approach to color field abstraction.</Category>
					<Category title="Queens">
						~6% Chance of Drop Named after historical female rulers, the Queens all bear unique stripes inspired by the many different mutations found
						in the tulip flower.
					</Category>
					<Category title="Faces">
						<span className="graphik text-lg">&lt;</span>1% Chance of Drop Inspired by the eye-like markings found on butterflies, reptiles, cat,
						birds and fish.
					</Category>
					<Category title="Ragnarok">
						<span className="graphik text-lg">&lt;</span>0.5% Chance of Drop Inspired by Andy Warhol&rsquo;s Shot Marilyns paintings. In 1964, Warhol
						painted five Marilyns with different colored backgrounds and they were stored at his famous studio loft, The factory. Four of these five
						paintings would become infamous after an incident that left bullet holes through the forehead of Ms. Monroe.
					</Category>
				</div>
				<div className="mt-6">
					<Link href="/faq">
						<a className="mt-14">Have a Question?</a>
					</Link>
				</div>
			</div>
		</>
	);
}
